import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import withAuth from '../../withAuth';

import PortalLayout from "../../layout/portal-layout";
import { loadUserProfile } from '../../model/profile/actions';

class MyView extends Component {

  componentDidMount() {
    this.props.loadUserProfile();
  }

  render() {
    return (
      <PortalLayout>
        {/* Begin Page Content */}
        <div id={'my-view-container'} className="container-fluid">

          {/* Page Heading */}
          <h1 className="h3 mb-4 text-gray-800">My View</h1>

        </div>
        {/* /.container-fluid */}

      </PortalLayout>
    );
  }

}

const mapStateToProps = (state, ownProps) => ({
  profile: state.profile
});

export default withAuth(withRouter(connect(mapStateToProps, { loadUserProfile })(MyView)))